import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'global/react-mui/theme/colors';

const partners = {
	display: 'flex',
	minWidth: '150px',
	gap: 10,
	alignItems: 'center',
};

export const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		minHeight: 192,
		alignItems: 'center',
		justifyContent: 'space-around',
		borderBottom: `1px solid ${colors['silver-grey']}`,
		paddingLeft: 32,
		paddingRight: 32,
		cursor: 'pointer',
		borderRadius: 'unset',
		boxShadow: 'unset',
		'&:hover': {
			backgroundColor: colors['light-blue-90-white'],
		},
	},
	isFocussed: {
		backgroundColor: colors['light-blue-90-white'],
	},
	details: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: '50%',
		maxWidth: '50%',
	},
	content: {
		flex: '1 0 auto',
	},
	cover: {
		width: 130,
		minWidth: 130,
		maxWidth: 130,
		height: 130,
		'@media (min-width:1280px) and (max-width:1390px)': {
			width: 98,
			minWidth: 98,
			maxWidth: 98,
			height: 98,
		},
	},
	companyName: {
		fontSize: 22,
		fontWeight: 500,
		marginBottom: 8,
	},
	partners: {
		display: 'flex',
		minWidth: '150px',
		gap: 10,
		justifyContent: 'center',
		alignItems: 'center',
	},
	certificate: {
		...partners,
		justifyContent: 'flex-start',
	},
	partner: {
		...partners,
		justifyContent: 'flex-end',
	},
	partnersCertified: {
		...partners,
		justifyContent: 'center',
	},
	roundedButton: {
		borderRadius: 32,
		height: 35,
		fontSize: 14,
		color: colors['dark-grey'],
		whiteSpace: 'nowrap',
		minWidth: '90px',
		marginLeft: '8px',
	},
	companyReplacementIcon: {
		height: '130px',
		width: '130px',
		color: colors['primary'],
		'@media (min-width:1280px) and (max-width:1390px)': {
			width: '98px',
			height: '98px',
		},
	},
	certificateBadge: {},
	partnerBadge: {},
}));
